import { Skeleton } from '@r/components/ui/skeleton.tsx';
import { CardContent, CardHeader, CardTitle } from '@ui/card.tsx';

export function BarChartSkeleton() {
  const columns = Array.from({ length: 12 }, () => ({ height: Math.floor(Math.random() * 100) }));

  return (
    <>
      <CardHeader className="space-y-0">
        <CardTitle className="flex items-center mb-6 space-x-2 text-xl font-author-complete font-regular">
          <Skeleton className="h-8 aspect-square" />
          <Skeleton className="w-6/12 h-8" />
        </CardTitle>

        <span>
          <Skeleton className="w-4/12 h-8 mb-5" />
          <Skeleton className="w-3/12 h-6" />
        </span>
      </CardHeader>

      <CardContent className="mt-20 h-[15rem] flex-grow font-regular">
        <div className="flex justify-center w-full h-full">
          {columns.map((column, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-end w-1/12 h-full text-muted-foreground"
            >
              <div className="mb-2 flex h-full w-[60%] flex-col justify-end md:w-[45%] lg:w-[50%] xl:w-[45%]">
                <Skeleton
                  className="w-full rounded-full"
                  style={{
                    height: `${column.height}%`
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </>
  );
}
